import React from 'react';
import { CubeIcon } from '@fronton/icons-react';
import { DesignRegistrationPanel } from 'common/components';
import { BATHROOM_ELEMENT_BLOCK } from '../../../bathroom-constants';
import { BATHROOM_CALCULATOR_HREF } from '../../new-bathroom-constants';

type BathroomDesignPanelProps = {
  designRegistrationHref: string;
};

const PANEL_TEXT = 'Запишитесь на\u00A0бесплатное проектирование или рассчитайте примерную стоимость ванной комнаты в\u00A0нашем калькуляторе';
const MOBILE_PANEL_TEXT = 'Запишитесь на\u00A0проектирование или рассчитайте стоимость в\u00A0калькуляторе\u00A0\u2014 это бесплатно';

export const NewBathroomDesignPanel: React.FC<BathroomDesignPanelProps> = ({ designRegistrationHref }) => (
  <DesignRegistrationPanel
    structure={{
      panel: {
        content: {
          leftIcon: CubeIcon,
          iconColor: 'accent-primary',
          iconType: 'duotone',
          text: PANEL_TEXT,
        },
        actionBlock: [
          {
            elementBlock: BATHROOM_ELEMENT_BLOCK,
            href: BATHROOM_CALCULATOR_HREF,
            invert: true,
            label: 'Узнать цену',
            target: '_blank',
            variant: 'pseudo',
          },
          {
            elementBlock: BATHROOM_ELEMENT_BLOCK,
            href: designRegistrationHref,
            label: 'Записаться',
            target: '_blank',
            variant: 'accent',
          },
        ],
      },
      mobilePanel: {
        content: {
          icon: CubeIcon,
          iconColor: 'accent-primary',
          iconType: 'duotone',
          text: MOBILE_PANEL_TEXT,
        },
        mobileButton: {
          elementBlock: BATHROOM_ELEMENT_BLOCK,
          openModal: true,
          label: 'Записаться на проектирование',
        },
        actionBlock: [
          {
            elementBlock: BATHROOM_ELEMENT_BLOCK,
            href: designRegistrationHref,
            label: 'Записаться',
            target: '_blank',
            variant: 'accent',
          },
          {
            elementBlock: BATHROOM_ELEMENT_BLOCK,
            invert: true,
            label: 'Узнать цену',
            href: BATHROOM_CALCULATOR_HREF,
            target: '_blank',
            variant: 'pseudo',
          },
        ],
      },
    }}
  />
);
